import Box from "@mui/material/Box";
import { CardProps } from "types";

const Card = ({ children, className }: CardProps) => (
  <Box
    className={className}
    sx={(theme) => ({
      maxWidth: "28rem",
      width: "100%",
      mx: "auto",
      backdropFilter: "blur(16px)",
      bgcolor: "background.paper",
      borderRadius: `${Number(theme.shape.borderRadius) * 2}px`,
      border: "1px solid",
      borderColor: "divider",
      px: "2rem",
      py: "3rem",
      color: "text.primary",
      position: "relative",
      overflow: "hidden",
    })}
  >
    {children}
  </Box>
);

export default Card;
